import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { QuillModule } from 'ngx-quill';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoNavigationModule } from 'tsui/@treo';
import { TreoScrollbarModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { AccountHooksComponent } from 'app/modules/settings/account-hooks/account-hooks.component';
import { AddAccountHookComponent } from 'app/modules/settings/account-hooks/add-account-hook/add-account-hook.component';
import { AccountHooksDetailsComponent } from 'app/modules/settings/account-hooks/details/details.component';
import { AccountHooksListComponent } from 'app/modules/settings/account-hooks/list/list.component';
import { accountHooksRoutes } from 'app/modules/settings/account-hooks/account-hooks.routing';

@NgModule({
  declarations: [
    AccountHooksComponent,
    AddAccountHookComponent,
    AccountHooksDetailsComponent,
    AccountHooksListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(accountHooksRoutes),
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSidenavModule,
    QuillModule.forRoot(),
    TreoFindByKeyPipeModule,
    TreoNavigationModule,
    TreoScrollbarModule,
    SharedModule,
  ],
})
export class AccounHooksModule {}
